import { useQuery } from "@tanstack/react-query";
import adminApiClient, { CollabpayWidgetData } from "../../api/admin";

const useCollabpayWidgetData = () => {
  return useQuery<CollabpayWidgetData>({
    queryKey: ["collabpayWidgetData"],
    queryFn: () => adminApiClient.getCollabpayWidgetData(),
  });
};

export default useCollabpayWidgetData;
